import { render, staticRenderFns } from "./BaseballArena.vue?vue&type=template&id=6efb1ad2&scoped=true"
import script from "./BaseballArena.vue?vue&type=script&lang=js"
export * from "./BaseballArena.vue?vue&type=script&lang=js"
import style0 from "./BaseballArena.vue?vue&type=style&index=0&id=6efb1ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb1ad2",
  null
  
)

export default component.exports